import axiosInstance from "../axios/axios";

const getSupplierList = async (id) => {
  try {
    const response = await axiosInstance.get(`/Supplier/getAllSuppliers/${id}`);
    //console.log("supplierList--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error fetching getSupplierList:", error);
  }
};

const getStateDropdown = async () => {
  try {
    const response = await axiosInstance.get(`/state/getAllStates`);
    //console.log("getStateDropdown--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const addSupplier = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/Supplier/addSupplier/${userId}/${companyId}`,
      body
    );
    //console.log("addSupplier--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const getSupplierById = async (id) => {
  try {
    const response = await axiosInstance.get(`/Supplier/getSupplier/${id}`);
    //console.log("getSupplierById--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const updateSupplier = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/Supplier/updateSupplier/${userId}/${companyId}`,
      body
    );
    //console.log("updateSupplier--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const getDepartmentDropdown = async () => {
  try {
    const response = await axiosInstance.get(`/Department/getAllDepartments`);
    //console.log("getDepartmentDropdown", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const getPositionDropdown = async () => {
  try {
    const response = await axiosInstance.get(`/Positions/getAllPositions`);
    //console.log("getPositionDropdown", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const addSupplierContact = async (userId, companyId, supplierId, body) => {
  try {
    const response = await axiosInstance.post(
      `/Supplier/addSupplierContact/${userId}/${companyId}/${supplierId}`,
      body
    );
    //console.log("addSupplierContact--->", response?.data);
    return response;
  } catch (error) {
    console.log("Error===>", error);
  }
};

const addSweetspot = async (userId, companyId, body) => {
  try {
    const response = await axiosInstance.post(
      `/Supplier/addSweetspot/${userId}/${companyId}`,
      body
    );
    return response;
  } catch (error) {
    console.error("Error fetching addSweetspot:", error);
  }
};

export const SupplierService = {
  getSupplierList,
  getStateDropdown,
  addSupplier,
  getSupplierById,
  updateSupplier,
  getDepartmentDropdown,
  getPositionDropdown,
  addSupplierContact,
  addSweetspot,
};
